<template>
    <label class="RelyingPartySelection">
        <NewDropdown
            class="RelyingPartySelection__select"
            :selected="selectedOption"
            :options="dropdownOptions"
            @input="onDropdownChange"
        />
    </label>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import sortBy from 'lodash/sortBy';

    import { NewDropdown } from '@evidentid/dashboard-commons/components/Dropdown';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';

    interface RelyingPartyOption {
        displayName: string;
        name: string;
    }

    export default defineComponent({
        name: 'RelyingPartySelection',
        components: {
            NewDropdown,
        },
        props: {
            options: {
                type: Array as PropType<RelyingPartyOption[]>,
                default: (): RelyingPartyOption[] => [],
            },
            value: {
                type: String as PropType<string | null>,
                default: null,
            },
        },
        emits: [ 'input' ],
        computed: {
            dropdownOptions(): DropdownOption[] {
                const sortedOptions = sortBy(this.options, ({ displayName }) => displayName?.toLowerCase());
                return sortedOptions.map((rp) => ({
                    label: rp.displayName || rp.name,
                    value: rp.name,
                }));
            },
            selectedOption(): DropdownOption | null {
                if (!this.value) {
                    return null;
                }
                const option = this.dropdownOptions.find((opt) => opt.value === this.value);
                return option || null;
            },
        },
        methods: {
            onDropdownChange(option: DropdownOption): void {
                if (option) {
                    this.$emit('input', option.value);
                }
            },
        },
    });
</script>
